module.exports = __webpack_public_path__ + "img/achievement_16.75af8d1e.png";